(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookStatisticDialogController', HandbookStatisticDialogController);

    HandbookStatisticDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HandbookStatistic', 'Handbook'];

    function HandbookStatisticDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HandbookStatistic, Handbook) {
        var vm = this;

        vm.handbookStatistic = entity;
        vm.clear = clear;
        vm.save = save;
        vm.handbooks = Handbook.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.handbookStatistic.id !== null) {
                HandbookStatistic.update(vm.handbookStatistic, onSaveSuccess, onSaveError);
            } else {
                HandbookStatistic.save(vm.handbookStatistic, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('teJHipsterApp:handbookStatisticUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
